module.exports = __webpack_public_path__ + "img/Z60_12.3c31de73.jpg";